module.exports = __webpack_public_path__ + "img/Cadenas@2x.927b57d9.png";